import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function seaPort() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`seaport/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`seaport/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('seaport/create', data);
    }

    function update(data) {
        return axiosInstance.patch('seaport/update', data);
    }

    function remove(id) {
        return axiosInstance.delete(`seaport/delete`, {
            data: {
                id: id
            }
        });
    }
}
